import classNames from 'classnames';

import type { BadgeSizes } from './types';
export const MAX_NOTIF = 99;
export const MAX_NOTIF_SM = 9;

export const variantsClassNames = {
  light: 'text-primary ctn-neutral-white outline outline-1 outline-disabled',
  primary: 'text-inverse ctn-brand-medium',
  error: 'text-inverse ctn-danger-strong',
};

export const getClassNamesBySize = (value: number): { [K in BadgeSizes]: string } => ({
  md: value > MAX_NOTIF ? 'w-xl h-lg' : 'w-lg h-lg',
  sm: classNames('h-md', value > MAX_NOTIF_SM ? 'w-max px-xxs' : 'w-md'),
  xs: 'w-xs h-xs',
});
